module.exports = __webpack_public_path__ + "shattered.ea2316224d45899c59bc.png";


//////////////////
// WEBPACK FOOTER
// ./~/inspinia/dist/patterns/shattered.png
// module id = 911
// module chunks = 2